import cusDateTime from '@/components/cusDateTime';
import {getFieldConfig} from '../source.js';
import dynamicMultField from '../source-common-module/dynamic-mult-field';
import dynamicSingleField from '../source-common-module/dynamic-single-field';
export default {
  name: "source-sup-offer",
  components:{
    cusDateTime,
    dynamicMultField,
    dynamicSingleField
  },
  data(){
    return {
      selectModel:'offer',
      sourceId:null,
      sourceDto:{},
      restTimeText:null,
      taxList:[],
      currentRotationDto:{},
      resetTimer:null,
      sourceNormalQuote:{},
      supplierId:null,
      round:null,
      isOfferdLine:0,
      noOfferdLine:0,
      isGiveUpLine:0,
      realShow:'rank',
      sourceExtendConfig:{},
      inquiryFieldList:[],
      offerFieldList:[],
      validOfferList:[],
      calcPriceList:[],
      noTaxAmountField:null,
      taxAmountField:null,
      techAttachList:[],
      busAttachList:[],
      person:{},
      defaultPar:{}
    }
  },
  methods:{
    getPerson(){
      this.$get('api/person/current').then((data) => {
        this.person = data;
      })
    },
    changeShowModel(str){
      this.selectModel = str;
    },
    getTaxList(){
      this.$get('api/tax/all').then((res) => {
        if(res){
          this.taxList = res;
        }
      })
    },
    changeSelected(data,str){
      this.$set(data,'selectShow',str);
    },
    backSourceList(){
      this.$router.go(-1);
    },
    changeShow(data){
      if(data.cellShow){
        this.$set(data,'cellShow',false);
        return;
      }
      this.$set(data,'cellShow',true);
    },
    getSourceDto(){
      this.$loadingShow();
      this.$get(`api/source/${this.sourceId}`).then((res) => {
        if(res){
          this.sourceDto = res;
          if(res.bidType === 'REAL'){
            this.selectModel = 'real';
          }
          this.sourceDto.sourceRotationList = this.sourceDto.sourceRotationList.sort((a,b) => a.round - b.round);
          this.currentRotationDto = this.sourceDto.sourceRotationList[this.sourceDto.currentRound - 1];
          if(this.currentRotationDto.tenderType === 'TECHNICAL'){
            this.selectModel = 'techAttach';
          }
          this.getDynamicField();
          this.getOfferInfo();
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    getReset(){
      if(this.currentRotationDto.endTime){
        let date = new Date();
        let nowTime = date.getTime();
        let endTime = Date.parse(this.currentRotationDto.endTime);
        if(nowTime > endTime){
          this.currentRotationDto.status = 'finish';
          this.restTimeText = '已截止';
          clearInterval(this.resetTimer);
        }else{
          let seconds = Math.floor(((endTime - nowTime) % 60000) / 1000);
          let minutes = Math.floor((endTime - nowTime) / 60000);
          let minute = minutes % 60;
          let hours = Math.floor(minutes / 60);
          let hour = hours % 24;
          let day = Math.floor(hours / 24);
          this.restTimeText = day + '天' + hour + '小时' + minute + '分钟' + seconds + '秒';
        }
      }else{
        clearInterval(this.resetTimer);
      }
    },
    getOfferInfo(){
      let obj = {
        id:this.sourceId
      };
      if(this.round){
        obj['round'] = this.round;
      }else{
        obj['round'] = this.sourceDto.currentRound;
      }
      if(this.supplierId){
        obj['supId'] = this.supplierId;
      }
      this.$get('api/sourceNormalQuote/round',obj).then((data) => {
        if(data){
          this.sourceNormalQuote = data;
          this.currentRotationDto.endTime = data.endTimeOfRotation;
          this.getReset();
          if(this.sourceNormalQuote.quoteDtList){
            this.sourceNormalQuote.quoteDtList.forEach((item) => {
              if(!item.attachment){
                item.attachment = {};
              }
              if(!item.dynamicValueJsonObj){
                item.dynamicValueJsonObj = {};
              }
              if(!item.dynamicValueJsonObj.data){
                item.dynamicValueJsonObj.data = {};
              }
              this.offerFieldList.forEach((field) => {
                if(field.dataType === 'Multiple'){
                  if(!item.dynamicValueJsonObj.data[field.tableName]){
                    item.dynamicValueJsonObj.data[field.tableName] = [];
                  }
                }else{
                  if(!item.dynamicValueJsonObj.data[field.tableName]){
                    item.dynamicValueJsonObj.data[field.tableName] = {};
                  }
                  if(field.inputType === 'LONG_TEXT' || field.inputType === 'ATTACHMENT'){
                    item.dynamicValueJsonObj.data[field.tableName][field.fieldName] = {};
                  }
                }
              })
            });
          }
          if(!this.sourceNormalQuote.attachmentList){
            this.sourceNormalQuote.attachmentList = [];
          }
          if(data.counts === 0){
            if(this.sourceDto.sourceType.supValidEnd && this.sourceDto.sourceType.supValidEnd.defaultValue){
              this.sourceNormalQuote.endDate = this.sourceDto.sourceType.supValidEnd.defaultValue;
            }
            if(this.sourceDto.sourceType.supValidStart && this.sourceDto.sourceType.supValidStart.defaultValue){
              this.sourceNormalQuote.beginDate = this.sourceDto.sourceType.supValidStart.defaultValue;
            }
            this.sourceNormalQuote.quoteDtList.forEach((item) => {
              if(this.sourceDto.sourceType.supMinOrderCounts && this.sourceDto.sourceType.supMinOrderCounts.defaultValue){
                item.minQuantity = this.sourceDto.sourceType.supMinOrderCounts.defaultValue;
              }
              if(this.sourceDto.sourceType.supSupplyDays && this.sourceDto.sourceType.supSupplyDays.defaultValue){
                item.deliveryDays = this.sourceDto.sourceType.supSupplyDays.defaultValue;
              }
            });
          }
          this.calateLine();
          this.calcalateAllMont();
          if(this.sourceNormalQuote.auctionRankings && this.sourceNormalQuote.auctionRankings.length){
            this.sourceNormalQuote.auctionRankings = this.sourceNormalQuote.auctionRankings.sort((a,b) =>{
              return a.ranking - b.ranking;
            })
          }
          this.distAttachList();
        }
      })
    },

    distAttachList(){
      let techAttachList = [];
      let busAttachList = [];
      this.sourceNormalQuote.attachmentList.forEach((item) => {
        if(!item.attachment){
          item.attachment = {};
        }
        if(item.type === '02' || item.type === '04'){
          busAttachList.push(item);
        }else{
          techAttachList.push(item);
        }
      });
      this.techAttachList = techAttachList;
      this.busAttachList = busAttachList;
    },

    getDynamicField(){
      if(this.sourceDto.priceTemplete){
        this.getFieldShow();
        const fieldConfig = getFieldConfig(this.sourceDto.priceTemplete);
        this.offerFieldList = fieldConfig.offerFieldList;
        this.inquiryFieldList = fieldConfig.inquiryFieldList;
        this.validOfferList = this.offerFieldList.filter((val) => {
          return (val.dataType !== 'Multiple' && val.inputRequired);
        });
        if(this.offerFieldList.filter(item => item.englishName === 'NTA')[0]){
          this.noTaxAmountField = this.offerFieldList.filter(item => item.englishName === 'NTA')[0];
        }
        if(this.offerFieldList.filter(item => item.englishName === 'TA')[0]){
          this.taxAmountField = this.offerFieldList.filter(item => item.englishName === 'TA')[0];
        }
        this.calcPriceList = fieldConfig.calcPriceList;
      }
    },
    /**
     * 获取是否显示字段
     * */
    getFieldShow(){
      this.defaultPar.materialType = this.sourceDto.priceTemplete.materialType;
      this.defaultPar.demandQuantity = this.sourceDto.priceTemplete.demandQuantity;
      this.defaultPar.baseUnit = this.sourceDto.priceTemplete.baseUnit;
      this.defaultPar.matPlant = this.sourceDto.priceTemplete.matPlant;
      this.defaultPar.matDemandDate = this.sourceDto.priceTemplete.matDemandDate;
      this.defaultPar.matPurchaseNum = this.sourceDto.priceTemplete.matPurchaseNum;
      this.defaultPar.matRemark = this.sourceDto.priceTemplete.matRemark;
      this.defaultPar.matAttach = this.sourceDto.priceTemplete.matAttach;
    },

    viewField(field,dynamicData){
      this.$refs.multMatDynamic.initData(field,dynamicData);
    },
    calateLine(){
      let length = this.sourceNormalQuote.quoteDtList.filter(val => !val.deleted).length;
      this.isGiveUpLine = this.sourceNormalQuote.quoteDtList.filter(val=>val.status=='giveUp').length;
      if(this.validOfferList.length){
        this.sourceNormalQuote.quoteDtList.forEach(val=>{
          if(val.status !== 'giveUp'){
            let bol = this.validOfferList.every((offerField) => {
              return (val.dynamicValueJsonObj && val.dynamicValueJsonObj.data && val.dynamicValueJsonObj.data[offerField.tableName] && (val.dynamicValueJsonObj.data[offerField.tableName][offerField.fieldName] || val.dynamicValueJsonObj.data[offerField.tableName][offerField.fieldName] === 0));
            });
            if(bol){
              val.status = 'quoted';
            }else{
              val.status = null;
            }
          }
        })
      }else {
        this.sourceNormalQuote.quoteDtList.forEach(val=>{
          if(val.status !== 'giveUp'){
            let bol = this.offerFieldList.every((offerField) => {
              return ((offerField.dataType !== 'Multiple' && offerField.fieldStatus === 'ACTIVATED') && val.dynamicValueJsonObj && val.dynamicValueJsonObj.data && val.dynamicValueJsonObj.data[offerField.tableName] && (val.dynamicValueJsonObj.data[offerField.tableName][offerField.fieldName] || val.dynamicValueJsonObj.data[offerField.tableName][offerField.fieldName] === 0) || (offerField.dataType === 'Multiple' && !offerField.hidden && val.dynamicValueJsonObj && val.dynamicValueJsonObj.data && val.dynamicValueJsonObj.data[offerField.tableName] && val.dynamicValueJsonObj.data[offerField.tableName].length));
            });
            if(bol){
              val.status = 'quoted';
            }else{
              val.status = null;
            }
          }
        })
      }
      this.isOfferdLine = this.sourceNormalQuote.quoteDtList.filter(val=>val.status=='quoted' && !val.deleted).length;
      this.noOfferdLine = length - this.isGiveUpLine - this.isOfferdLine;
    },
    //计算 报价含税总额 报价未税总额
    calcalateAllMont(){
      if(this.noTaxAmountField){
        this.sourceNormalQuote.untaxedAmount = this.sourceNormalQuote.quoteDtList.reduce((pre,val)=>{
          if(val.status !== 'giveUp' && val.dynamicValueJsonObj && val.dynamicValueJsonObj.data && val.dynamicValueJsonObj.data[this.noTaxAmountField.tableName] && val.dynamicValueJsonObj.data[this.noTaxAmountField.tableName][this.noTaxAmountField.fieldName]){
            return Number(val.dynamicValueJsonObj.data[this.noTaxAmountField.tableName][this.noTaxAmountField.fieldName]) + pre;
          }
          return pre;
        },0);
      }
      if(this.taxAmountField){
        this.sourceNormalQuote.taxedAmount = this.sourceNormalQuote.quoteDtList.reduce((pre,val)=>{
          if(val.status !== 'giveUp' && val.dynamicValueJsonObj && val.dynamicValueJsonObj.data && val.dynamicValueJsonObj.data[this.taxAmountField.tableName] && val.dynamicValueJsonObj.data[this.taxAmountField.tableName][this.taxAmountField.fieldName]){
            return Number(val.dynamicValueJsonObj.data[this.taxAmountField.tableName][this.taxAmountField.fieldName]) + pre;
          }
          return pre;
        },0);
      }
    },

    calculatePriceChange(field,data){
      if(this.calcPriceList.length){
        let calcIndex;
        if(field){
          for(let i = 0;i < this.calcPriceList.length;i++){
            if(field.fieldName === this.calcPriceList[i].fieldName){
              calcIndex = i;
            }
          }
        }
        this.calcPriceList.forEach((item,i) => {
          if((calcIndex || calcIndex === 0) && i <= calcIndex){
            return;
          }
          try {
            data.dynamicValueJsonObj.data[item.tableName][item.fieldName] = Math.floor(eval(item.inputRegEx) * 1000) / 1000;
          }catch (error) {
            console.log(error);
          }finally{

          }
        })
      }
      this.calcalateAllMont();
      this.calateLine();
    },

    taxChange(data,e){
      for(let i=0;i<this.taxList.length;i++){
        if(this.taxList[i].id === e){
          data.taxName = this.taxList[i].taxName;
          data.taxCode = this.taxList[i].taxCode;
          data.taxRate = this.taxList[i].taxRate;
          this.calculatePriceChange(null,data);
          break;
        }
      }
    },
    validOfferData(){
      if(this.currentRotationDto.tenderType !== 'TECHNICAL'){
        let quoteFileRequired= this.sourceDto.sourceType.quoteFile.isMustInput;
        if(quoteFileRequired){
          //报价文件 是必填的
          if(!(this.sourceNormalQuote.attachment && this.sourceNormalQuote.attachment.attachFile && this.sourceNormalQuote.attachment.attachFile.length)){
            this.$vux.toast.text('请补充报价文件');
            return;
          }
        }
        if(this.sourceDto.sourceType.supValidStart.isMustInput && !this.sourceNormalQuote.beginDate){
          this.$vux.toast.text('请补充价格有效期开始时间');
          return;
        }
        if(this.sourceDto.sourceType.supValidEnd.isMustInput && !this.sourceNormalQuote.endDate){
          this.$vux.toast.text('请补充价格有效期结束时间');
          return;
        }

        let quoteDtRemarkRequired= this.sourceDto.sourceType.quoteDtRemark.isMustInput;
        let quoteDtFileRequired= this.sourceDto.sourceType.quoteDtFile.isMustInput;
        let minQuantityRequired= this.sourceDto.sourceType.supMinOrderCounts.isMustInput;
        let deliveryDaysRequired= this.sourceDto.sourceType.supSupplyDays.isMustInput;
        let validBol = this.sourceNormalQuote.quoteDtList.every((val) => {
          if(val.status === 'giveUp'){
            return true;
          }
          if(minQuantityRequired && !(val.minQuantity || val.minQuantity === 0)){
            this.$vux.toast.text('请完善最小起订量必填项');
            return false;
          }
          if(deliveryDaysRequired && !(val.deliveryDays || val.deliveryDays === 0)){
            this.$vux.toast.text('请完善供货天数必填项');
            return false;
          }
          if(quoteDtRemarkRequired && !(val.remark || val.remark === 0)){
            this.$vux.toast.text('请完善报价备注必填项');
            return false;
          }
          if(quoteDtFileRequired && !(val.attachment && val.attachment.attachFile && val.attachment.attachFile.length)){
            this.$vux.toast.text('请完善报价附件必填项');
            return false;
          }
          return this.validOfferList.every((field) => {
            if(val.dynamicValueJsonObj && val.dynamicValueJsonObj.data && val.dynamicValueJsonObj.data[field.tableName] && (val.dynamicValueJsonObj.data[field.tableName][field.fieldName] || val.dynamicValueJsonObj.data[field.tableName][field.fieldName] === 0)){
              return true;
            }else{
              this.$vux.toast.text(`请完善${field.name}必填项`);
              return false;
            }
          });
        });
        if(!validBol){
          return;
        }
        if(this.busAttachList){
          for(let i=0;i<this.busAttachList.length;i++){
            let attachObj = this.busAttachList[i];
            if(!attachObj.type){
              this.selectModel = 'busAttach';
              this.$vux.toast.text(`请选择第${i+1}个商务文件的类型`);
              return;
            }
            if(!(attachObj.attachment && attachObj.attachment.attachFile && attachObj.attachment.attachFile.length)){
              this.selectModel = 'busAttach';
              this.$vux.toast.text(`请上传第${i+1}个商务文件的文件`);
              return;
            }
          }
        }
      }
      if(this.currentRotationDto.tenderType !== 'COMMERCIAL'){
        if(this.techAttachList){
          for(let i=0;i<this.techAttachList.length;i++){
            let attachObj = this.techAttachList[i];
            if(!attachObj.type){
              this.selectModel = 'techAttach';
              this.$vux.toast.text(`请选择第${i+1}个技术文件的类型`);
              return;
            }
            if(!(attachObj.attachment && attachObj.attachment.attachFile && attachObj.attachment.attachFile.length)){
              this.selectModel = 'techAttach';
              this.$vux.toast.text(`请上传第${i+1}个技术文件的文件`);
              return;
            }
          }
        }
      }
      return true;
    },
  //  放弃单个物料
    giveUpMat(data){
      if(data.status !== 'giveUp'){
        data.status = 'giveUp';
      }else{
        data.status = 'notOffer';
      }
      this.calateLine();
      this.calcalateAllMont();
    },
  //  价格明细、阶梯价、年度降价提示前往pc操作
    editDetail(){
      this.$vux.toast.text('暂不支持在手机端操作明细，请前往pc端操作');
    },
  //  报价
    offer(){
      if(this.validOfferData()){
        this.$loadingShow();
        this.$post('api/sourceNormalQuote/commit',this.sourceNormalQuote).then((res) => {
          this.$vux.toast.text('报价成功');
          this.$loadingHide();
          this.getOfferInfo();
        }).catch(() => {
          this.$loadingHide();
        });
      }
    },
  //  实时竞价信息展示
    changeRealShow(str){
      this.realShow = str;
    },

    newAttach(str){
      let obj = {attachment:{},uploadedTime:new Date()};
      if(this.person){
        obj.uploadedBy = this.person.name;
      }
      if(str === 'bus'){
        this.busAttachList = [...this.busAttachList,obj];
      }else{
        this.techAttachList = [...this.techAttachList,obj];
      }
      if(!this.sourceNormalQuote.attachmentList){
        this.sourceNormalQuote.attachmentList = [];
      }
      this.sourceNormalQuote.attachmentList.push(obj);
      setTimeout(() => {
      },3200);
    },

    deleteAttach(item,str){
      if(str === 'bus'){
        this.busAttachList = this.busAttachList.filter((data) => {
          return data !== item;
        })
      }else{
        this.techAttachList = this.techAttachList.filter((data) => {
          return data !== item;
        })
      }
      this.sourceNormalQuote.attachmentList = this.sourceNormalQuote.attachmentList.filter((data) => {
        return data !== item;
      });
    }
  },
  mounted(){
    this.getPerson();
    this.getTaxList();
    this.sourceId = this.$route.params.id;
    if(this.$route.params.supId){
      this.supplierId = this.$route.params.supId;
      this.getSourceDto();
    }else{
      this.$get(`api/supplier/current-sample`).then((res) => {
        this.supplierId = res.id;
        this.getSourceDto();
      })
    }
  },
  beforeDestroy(){
    clearInterval(this.resetTimer);
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-sup/source-sup-offer.js